import React from 'react'
import OurTeam from '../components/OurTeam'

export default function ProjeEkibimiz() {
  return (
    <div className='py-32'>    <OurTeam/></div>
  )
}
